import React from "react";
import { render } from "react-dom";
import ProductRatingStars from "../widgets/productrating/ratings-stars";

// Book preview
let elems = document.querySelectorAll(".review-rating");
if (elems.length > 0)
    elems.forEach(elem =>
        render(
            <ProductRatingStars
                elem={elem}
                size={20}
                src="/images/icon/new-star-{value}.svg"
            />,
            elem
        )
    );
